import featureTesting from './FeatureTesting';

export const hasTouch = () => featureTesting.getTestResult('touchevents');
